export const pointsOptions = [
  { name: '1', value: 1 },
  { name: '2', value: 2 },
  { name: '3', value: 3 },
];

export const examCategoriesOptions = [
  { name: 'A', value: 'A' },
  { name: 'B', value: 'B' },
  { name: 'C', value: 'C' },
];

export const knowledgeTypeOptions = [
  { name: 'Podstawowa', value: 1 },
  { name: 'Specjalistyczna', value: 2 },
];

export const questionCategoriesOptions = [
  { name: 'Znaki ostrzegawcze' }, 
  { name: 'Znaki informacyjne, kierunku i miejscowości, uzupełniające' },
  { name: 'Sygnały świetlne, sygnały dawane przez kierującego ruchem' },
  { name: 'Skrzyżowania ze znakami określającymi pierwszeństwo przejazdu' },
  { name: 'Znaki zakazu, nakazu' },
  { name: 'Znaki drogowe poziome ' },
  { name: 'Sygnały świetlne, sygnały dawane przez kierującego ruchem' },
  { name: 'Włączanie się do ruchu, skrzyżowania równorzędne' },
  { name: 'Skrzyżowania z sygnalizacją świetlną' }
];